exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "::ng-deep .tooltip-inner {\n  padding: 5px 5px;\n  opacity: 1;\n}\n\n.device-card-info {\n  color: black;\n  text-align: left;\n  background: #fff;\n  opacity: 1;\n}", ""]);

